import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn `cn`-Helper: kombiniert Tailwind-Klassen + dedupliziert Konflikte.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
